// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import React from 'react';

import { interpolateWith } from 'web-core/src/utils/format';

const NOT_FOUND_MSG = 'translation not found';

const mapStateToProps: Object = state => ({
  translations: _.get(state, 'contentfulData.translations', {}),
});

type Props = {
  className: string,
  fallback: string,
  path: string,
  translations: Object,
  using: Object | null,
};

const ContentfulTranslate = (props: Props) => {
  const { className, fallback, path, translations, using } = props;
  let content = _.get(translations, path, fallback);
  if (!_.isString(content)) {
    content = documentToHtmlString(content);
  }
  if (!_.isEmpty(using)) {
    content = interpolateWith(content, using);
  }
  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: content,
      }} />
  );
};

ContentfulTranslate.defaultProps = {
  className: '',
  fallback: NOT_FOUND_MSG,
  translations: {},
  using: null,
};

export default connect(mapStateToProps, {})(ContentfulTranslate);
